import { FloatingActionBar } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

interface CompensationSaveBarProps {
    /** Shown once the draft differs from what is saved: nothing to save, nothing to offer. */
    isDirty: boolean;
    isSaving: boolean;
    /** Saving is refused while the draft cannot be written (an audience without a criterion); the
     * audience section says why, next to the choice that has to be completed. */
    isSaveBlocked: boolean;
    onDiscard: () => void;
    onSave: () => void;
}

/**
 * Saves or discards the draft. While there is nothing to save the bar keeps its box and only stops
 * being seen, heard and reachable, so the page does not shift under the first keystroke.
 */
export const CompensationSaveBar = ({
    isDirty,
    isSaving,
    isSaveBlocked,
    onDiscard,
    onSave,
}: CompensationSaveBarProps) => {
    const { t } = useAmelioTranslations();

    const isOffered = isDirty || isSaving;

    return (
        <div
            className={isOffered ? undefined : 'invisible'}
            aria-hidden={!isOffered}
            inert={!isOffered}
        >
            <FloatingActionBar
                variant={'glass'}
                cancelLabel={t('compensation.saveBar.discard')}
                saveLabel={t('compensation.saveBar.save')}
                savingLabel={t('compensation.saveBar.saving')}
                onCancel={onDiscard}
                onSave={onSave}
                isSaving={isSaving}
                isSaveDisabled={isSaving || isSaveBlocked}
                dataTestId={'compensation-save-bar'}
                cancelDataTestId={'compensation-discard-button'}
                saveDataTestId={'compensation-save-button'}
            />
        </div>
    );
};
